import { createContext, useContext } from 'react';
export const ContentGridContext = /*#__PURE__*/createContext({
  columnCount: null,
  range: null
});
export const useContentGrid = () => useContext(ContentGridContext);
//# sourceMappingURL=content-grid-context.js.map